export default __webpack_public_path__ + "static/media/asia_banner_highlight.519b4a0e.png";